/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postRequestToken } from '../fn/tokens/post-request-token';
import { PostRequestToken$Params } from '../fn/tokens/post-request-token';
import { TokenResponse } from '../models/token-response';

@Injectable({ providedIn: 'root' })
export class TokensService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postRequestToken()` */
  static readonly PostRequestTokenPath = '/requesttoken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postRequestToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  postRequestToken$Response(params: PostRequestToken$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenResponse>> {
    const obs = postRequestToken(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postRequestToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postRequestToken(params: PostRequestToken$Params, context?: HttpContext): Observable<TokenResponse> {
    const resp = this.postRequestToken$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TokenResponse>): TokenResponse => r.body)
    );
  }

}
